import { render, staticRenderFns } from "./FrameworkListFramework.vue?vue&type=template&id=6b822e88&"
import script from "./FrameworkListFramework.vue?vue&type=script&lang=js&"
export * from "./FrameworkListFramework.vue?vue&type=script&lang=js&"
import style0 from "./FrameworkListFramework.vue?vue&type=style&index=0&id=6b822e88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSpacer,VTooltip})
